import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip, Dropdown, NavLink } from 'react-bootstrap';
const gallerytip = <Tooltip>Gallery</Tooltip>;
const gridtip = <Tooltip>Grid</Tooltip>;
const listtip = <Tooltip>List</Tooltip>;
const maptip = <Tooltip>Map</Tooltip>;
const bedstip = <Tooltip>Beds</Tooltip>;
const bathstip = <Tooltip>Bathrooms</Tooltip>;
const areatip = <Tooltip>Square meters</Tooltip>;
const ListingCard = ({ item }) => {
  return (
    <div className='listing'>
      <div className='listing-thumbnail'>
        <Link to={`/listings/${item.id}`}>
          <img src={item.pictures[0]?.url} alt='listing' />
        </Link>
        <div className='listing-badges'>
          {item.star === true ? (
            <span className='listing-badge featured'>
              {' '}
              <i className='fas fa-star' />{' '}
            </span>
          ) : (
            ''
          )}
          {item.assetType.id === 1 ? (
            <span className='listing-badge sale'>On Sale</span>
          ) : (
            ''
          )}
          {item.assetType.id === 2 ? (
            <span className='listing-badge rent'>For Rent</span>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className='listing-body'>
        <div className='listing-author'>
          <img
            src={
              item.agent.image
                ? item.agent.image
                : process.env.PUBLIC_URL + '/assets/img/people/1.jpg'
            }
            alt='author'
          />
          <div className='listing-author-body'>
            <p>
              {' '}
              <Link to={`/agents/${item.agent.id}`}>
                {item.agent.name}
              </Link>{' '}
            </p>
            <span className='listing-date'>
              {new Date().valueOf() >= new Date(item.availableFrom).valueOf()
                ? 'Available'
                : new Date(item.availableFrom).toLocaleDateString()}
            </span>
          </div>
        </div>

        <span className='listing-price'>
          €
          {new Intl.NumberFormat().format(
            item.assetType.id === 1
              ? item.salePrice
              : item.llPrice || item.slPrice
          )}
          {item.assetType.id !== 1 && <span>/month</span>}{' '}
        </span>
        <span className='listing-address'>
          {' '}
          <i className='fas fa-map-marker-alt' /> {item.locationType.name}
        </span>
        <div className='acr-listing-icons'>
          <OverlayTrigger overlay={bedstip}>
            <div className='acr-listing-icon'>
              <i className='flaticon-bedroom' />
              <span className='acr-listing-icon-value'>
                {item.numberOfBedrooms}
              </span>
            </div>
          </OverlayTrigger>
          <OverlayTrigger overlay={bathstip}>
            <div className='acr-listing-icon'>
              <i className='flaticon-bathroom' />
              <span className='acr-listing-icon-value'>
                {item.numberOfBathrooms}
              </span>
            </div>
          </OverlayTrigger>
          <OverlayTrigger overlay={areatip}>
            <div className='acr-listing-icon'>
              <i className='flaticon-ruler' />
              <span className='acr-listing-icon-value'>
                {new Intl.NumberFormat().format(item.squareMeters)}
              </span>
            </div>
          </OverlayTrigger>
        </div>
        <div className='listing-gallery-wrapper'>
          <Link
            to={`/listings/${item.id}`}
            className='btn-custom btn-sm secondary'
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
